export default "__VITE_ASSET__Crvk8E$e__"